<template>
  <div>
    <div class="m-background m-background--media-1"></div>
    <div class="m-background__overlay"></div>
    <img src="~@/assets/images/rics-logo.png" class="m-logo m-logo--top-right" />
    <div class="l-container">
      <h1 class="v-home__title">Mega <br/>CITY</h1>
      <router-link class="m-btn m-btn--left m-btn__primary"
        :to="{ name: 'explore-careers' }">Explore Careers</router-link>
      <router-link class="m-btn m-btn--left m-btn__primary"
        :to="{ name: 'confidence' }">Play Game</router-link>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  created() {
    this.resetState();
  },
  methods: {
    ...mapActions(['resetState']),
  },
};
</script>

<style lang="scss" scoped>
  .v-home__title {
    margin-top: 170px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue